export const AdminViews = {
  DEVICEVIEW: "deviceview",
  MANAGERVIEW: "managerview",
  USERVIEW: "userview",
};

export type AdminViewsType = "deviceview" | "managerview" | "userview";

export const MAX_SAVED_SEARCHED_ITEMS = 100;
